import { useMemo } from "react";

import {
  formatTimeZoneDifference,
  getTimeZoneOffsetMinutes,
} from "./roster-table-utils.js";

export const RosterLocalTime = ({
  tickCounter,
  timeZone,
}: {
  tickCounter: number;
  timeZone: string;
}) => {
  // Lint exception: tickCounter forces re-render
  const formatted = useMemo(() => {
    try {
      const now = new Date();
      const localUses12HourClock =
        new Intl.DateTimeFormat(undefined, {
          hour: "numeric",
        }).resolvedOptions().hour12 ?? false;
      const time = new Intl.DateTimeFormat(undefined, {
        hour: localUses12HourClock ? "numeric" : "2-digit",
        hour12: localUses12HourClock,
        minute: "2-digit",
        timeZone,
      }).format(now);
      const localOffsetMinutes = -now.getTimezoneOffset();
      const targetOffsetMinutes = getTimeZoneOffsetMinutes(timeZone, now);

      if (targetOffsetMinutes === null) {
        return time;
      }

      const deltaMinutes = targetOffsetMinutes - localOffsetMinutes;

      if (deltaMinutes === 0) {
        return time;
      }

      return `${time} (${formatTimeZoneDifference(deltaMinutes)})`;
    } catch {
      return null;
    }
  }, [timeZone, tickCounter]);

  return <span>{formatted ?? "—"}</span>;
};
